import React from 'react';
import { useParams } from 'react-router-dom';

import { fieldObjectTeds } from './auxiliarTeds';
import { SubAbasTeds, SubAbasTedsNovo } from './subabasTeds';
import DestaquesComponente from '../../../../components/Destaques';
import { ENTITY } from '../../../../utils/entityNames';

const TedsDestaques: React.FC = () => {
  const params = useParams();
  const fichaID = String(params.id);

  return (
    <DestaquesComponente
      tab="ted"
      id_tab={fichaID}
      retorno="/daf/proaq/teds"
      arquivo_export="sisaf_proaq_teds_destaques.xlsx"
      fieldObject={fieldObjectTeds}
      subAbas={fichaID !== 'undefined' ? SubAbasTeds(fichaID) : SubAbasTedsNovo}
      entity={ENTITY.ENTITY_Ted}
    />
  );
};

export default TedsDestaques;
